import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import './webFormSimple.scss'

function WebformSimples(props) {
  const { data, themeClasses } = props
  const [formLoading, setFormLoading] = useState(true)

  useEffect(async () => {
    let counter = 0
    const script = `<script src="/webform/${data.formId}/share.js" type="text/javascript"></script>`
    const options = {
      done: () => {
        const iframe = document.querySelector('.webform-share-iframe')
        if (!iframe && counter <= 3) {
          counter++
          postscribe('#form', script, options)
        }
        setFormLoading(false)
      },
      error: (err) => {
        console.log('err', err)
      },
    }
    const postscribe = await require('postscribe')
    setTimeout(() => {
      postscribe('#form', script, options)
    }, 500)
  }, [])

  return (
    <Container fluid="fluid" className={`web-form-simple ${themeClasses}`}>
      <Container>
        <Row>
          <Col>
            <div id="form">
              {formLoading && (
                <Row className="justify-content-md-center my-5">
                  <Col md="auto" className="text-center">
                    <Spinner animation="border" />
                  </Col>
                </Row>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default WebformSimples
